import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
// import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { FinyearService, WorkOrderService } from "../../../services/index";
import * as commonActions from "../../../store/actions/common.actions";

@Component({
  selector: "party-tab",
  // host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./bagMaster.html",
})
export class bagMasterComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  bagList: any[];
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter: any;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "order_from",
    orderDir: "asc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];
 selected: any = [];
  filterExpand = false;

  agentList$ = [];
  companyInfo: any = [];
  finyearCtrl: FormControl = new FormControl();
  finyearList = [];
  constructor(
    private finyearService: FinyearService,
    public store: Store<fromRootStore.State>,
    private Woservice: WorkOrderService,
    public toasterService: ToasterService
  ) {
    this.filter = {
      item_type: "",
      prefix: '',
      barcode: '',
      range_from: '',
      range_to: ''
    };
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;*/
  }

  ngOnInit(): void {


 this.columns = [
       {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: true,
          checkboxable: true,
          width: 30,
        },
    {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
      {
        name: "Item Type",
        prop: "item_type",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
         {
        name: "Prefix",
        prop: "prefix",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Barcode",
        prop: "barcode",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Formal",
        prop: "formal",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Casual",
        prop: "casual",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      { name: 'Action', prop: 'sno', minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: this.editDeleteTemplate }
    ];

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
    // this.applyFilter();
  }

  // hotkeys(event) {
  //   if (this.active) {
  //     if (event.ctrl && event.keyCode === 13) {
  //       this.addEditSeason("Add", "");
  //     }
  //     if (event.keyCode === 27) {
  //       this.bsModalRef.hide();
  //     }
  //   }
  // }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getbagList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getbagList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getbagList();
  }

 

  getbagList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 0)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      item_type: this.filter.item_type,
      prefix: this.filter.prefix,
      range_from: this.filter.range_from,
      range_to: this.filter.range_to,
      barcode: this.filter.barcode
      // tabTitle: this.title
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.Woservice
      .getbagMasterList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.bagList = res.data;
      });
  }

  clearFilter(): void {
    this.filter = {
      item_type: "",
      prefix: '',
      barcode: '',
      range_from: '',
      range_to: ''
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getbagList();
  }

  printRow(row){
      this.selected = [];
      this.selected.push({ ...row })
      this.Barcodeprint();
  }

  Barcodeprint(){
    if (!this.selected.length) {
      swal("ERROR", "Pls select atleast One!!", "error")
      return
    }

    let params: any = {}
    let data = this.selected.map(item => ({ item: item.item_type, barcode: item.barcode }));
    
    data = data.flatMap(item => [item, item]);
    params['data'] = JSON.stringify(data)

    let that = this;
    that.Woservice.bagBarcodeprint(params).then(function (res: any) {
      if (res.success) {
        that.selected.splice(0, that.selected.length);
         that.getbagList();
        that.toasterService.pop({
          bodyOutputType: 1,
          type: "success",
          title: "success".toUpperCase(),
          body: "PRINTED SUCCESSFULLY",
        });
      }
    })

  }


  addEditSeason(mode: string, row: any): void {
         
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getbagList();
    });

    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {

   tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD BAG MASTER",
          title: "ADD BAG MASTER",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "ADD BAG MASTER",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  finyearFn(season: number) {
    let list: any = [];
    let that = this;
    list = this.finyearList;

    let id = season && season ? season : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });

      this.filter.fin_id = id;
      return fitem["finyear"];
    }
    return "";
  }
   onSelect({ selected }, ind) {


    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
 

  }
deleteRow(row){
this.selected = [];
this.selected.push({...row})
this.deleteBagDetails();
}
  deleteBagDetails(): void {
  if(!this.selected.length){
    swal("ERROR", "Pls select atleast One!!", "error")
    return
  }
    let params = {
      selected: JSON.stringify(this.selected)
    };
    let that = this;
    swal({
      title: "Are you sure to delete",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.Woservice
          .deleteBagDetails(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
         
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }
            else {
            that.getbagList();
            }
            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        /*if (dismiss === 'cancel') {
              swal(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              )
            }*/
      }
    );
  }

  addEditDetails(mode: string): void {
    let row = {
      sp_id: 1,
      fin_id: 1,
      sales_target: 4000,
      order_per: 50,
      order_target: 8000,
      fin_year: "2015-2016",
    };
    let tabObj = {
      action: "NewTab",
      params: {
        tabParent: "Master",
        tabName: "PlandetailsMasterComponent",
        mode: mode,
        data: row,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/bagMaster/bagMaster.ts